<div *ngIf="companiesList.length > 0">
  <p class="sec-title">Total Followings: {{companiesList.length}}</p>
  <div class="list-wrapper d-flex flex-wrap">
    <app-company-card *ngFor="let id of companiesList" [id]="id" class="card-company"></app-company-card>
  </div>
</div>
<p *ngIf="companiesList.length === 0" class="sec-title">Total Followings: 0</p>
